import { useState } from 'react';
import { loadSampleCase } from '../../lib/loadSampleCase';
import type { ExampleCase } from '../../lib/exampleCards';
import type { AppState } from '../../hooks/useAppState';

/** Hook used by all 5 example-loader variations. Tracks which case is in
 *  flight so the UI can show a loading state on the right chip/button. */
export function useSampleLoader(app: AppState) {
  const [loadingId, setLoadingId] = useState<ExampleCase['id'] | null>(null);
  const [error, setError] = useState<string | null>(null);

  const load = async (example: ExampleCase) => {
    setError(null);
    setLoadingId(example.id);
    try {
      await loadSampleCase(example, app);
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setLoadingId(null);
    }
  };

  return { loadingId, error, load };
}
